import { render, staticRenderFns } from "./RegisterProductPublic.vue?vue&type=template&id=5436cef3"
import script from "./RegisterProductPublic.vue?vue&type=script&lang=js"
export * from "./RegisterProductPublic.vue?vue&type=script&lang=js"
import style0 from "./RegisterProductPublic.vue?vue&type=style&index=0&id=5436cef3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports